import { Component, OnInit } from '@angular/core';
import { TestbackendService } from './testbackend.service';
import { Consulta } from 'src/core/consulta/consulta.types';

@Component({
  selector: 'app-testbackend',
  templateUrl: './testbackend.component.html',
  styleUrls: ['./testbackend.component.css']
})
export class TestbackendComponent implements OnInit {
  
  result: any;
  resultError: any;

  constructor(
    private _testBackendService: TestbackendService
  ){

  }
  
  ngOnInit(): void {
    this.getResult();
  }

  getResult(){
    this._testBackendService.getConsultas().subscribe({
      next: (data: Consulta[]) => {
        this.result = data;
      },
      error: (error: any) => {
        console.log('>>> error : ', error);
        this.resultError = error;
      }
    });
  }
}
